// The unit number a postventa feed row belongs to.
//
// `postventaObservationSchema.assetLabel` is built server-side as
// «{address}, unidad {unit}» (or the bare address when the asset has no
// unit) — the feed carries no separate unit field. The v2 list shows
// the number alone in its Unidad column (README §3), so this reads it
// back out of the label. When the label has no «, unidad » segment the
// whole label is returned, which is the address: better than nothing,
// never a made-up number.
const UNIT_SEP = ", unidad ";

export function unidadDe(assetLabel: string): string {
  const i = assetLabel.lastIndexOf(UNIT_SEP);
  return i === -1 ? assetLabel : assetLabel.slice(i + UNIT_SEP.length);
}
